<template>
  <validation-observer ref="AddDesignationForm" v-slot="{ invalid, errors }">
    <b-form @submit.prevent="formSubmitted">
      <b-row>
        <b-col sm="12">
          <b-form-group label="Department" label-for="departmentName">
            <b-form-select
              v-model="selectedDepartment"
              :options="departmentOptions"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Working Hours" label-for="workingHours">
            <validation-provider
              #default="{ errors }"
              name="Working Hours"
              rules="required|max_working_hours"
            >
              <b-form-input
                v-model="workingHours"
                name="workingHours"
                placeholder="Working Hours"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Designation Name" label-for="designationName">
            <validation-provider
              #default="{ errors }"
              name="Designation Name"
              rules="required"
            >
              <b-form-input
                v-model="designationName"
                name="designationName"
                placeholder="Designation Name"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- <b-col md="12">
          <b-form-group label="Minimum Salary" label-for="minimumSalary">
            <validation-provider #default="{ errors }" name="minimumSalary" rules="required|numeric_decimal|minValue">
              <b-form-input v-model.number="minimumSalary" type="number" name="minimumSalary" placeholder="Minimum Salary" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->
        <b-col md="12">
          <b-form-group label="Minimum Salary" label-for="minimumSalary">
            <validation-provider
              #default="{ errors }"
              name="minimumSalary"
              :rules="[
                { required: true, message: 'Minimum Salary is required' },
                {
                  numeric_decimal: true,
                  message: 'Please enter a valid number',
                },
                {
                  validate: (value) =>
                    value >= 0 || 'Salary cannot be negative',
                  message: 'Salary cannot be negative',
                },
              ]"
            >
              <b-form-input
                v-model.number="minimumSalary"
                @input="checkNegative"
                @blur="validate"
                type="number"
                name="minimumSalary"
                placeholder="Minimum Salary"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Maximum Salary" label-for="maximumSalary">
            <validation-provider
              #default="{ errors }"
              name="maximumSalary"
              :rules="[
                { required: true, message: 'Minimum Salary is required' },
                {
                  numeric_decimal: true,
                  message: 'Please enter a valid number',
                },
                {
                  validate: (value) =>
                    value >= 0 || 'Salary cannot be negative',
                  message: 'Salary cannot be negative',
                },
              ]"
            >
              <b-form-input
                v-model.number="maximumSalary"
                @input="checkNegative"
                @blur="validate"
                type="number"
                name="maximumSalary"
                placeholder="Maximum Salary"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- <b-col md="12">
          <b-form-group label="Maximum Salary" label-for="maximumSalary">
            <validation-provider #default="{ errors }" name="maximumSalary" rules="required|numeric_decimal|minValue">
              <b-form-input v-model.number="maximumSalary" type="number" name="maximumSalary" placeholder="Maximum Salary" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <b-col md="12" class="d-flex justify-content-between">
          <b-button type="submit" variant="primary" :disabled="invalid">
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>
<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "@validations";
import { mapActions, mapGetters } from "vuex";
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BSpinner,
  BFormSelect,
} from "bootstrap-vue";

extend("max_working_hours", {
  validate: (value) => {
    const isNumber = /^[0-9]*\.?[0-9]+$/.test(value);
    if (!isNumber) return false;

    const hours = parseFloat(value);
    return hours >= 0 && hours <= 24;
  },
  message: "Working hours must be a number between 0 and 24.",
});
extend("minValue", {
  validate: (value) => {
    if (this == null) {
      return true;
    }
    if (this.maximumSalary < this.minimumSalary) {
      return false;
    }
  },
  message: "Maximum salary must be greater than minimum salary!",
});

export default {
  name: "AddDesignation",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
  },
  props: {
    designation: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      selectedDepartment: null,
      workingHours: null,
      designationName: "",
      minimumSalary: "",
      maximumSalary: "",
    };
  },
  computed: {
    isSalaryInvalid() {
      return this.maximumSalary < this.minimumSalary;
    },
    ...mapGetters("departmentModule", ["departments"]),
    departmentOptions() {
      return this.departments.map((department) => ({
        text: department.departmentName,
        value: department.departmentId,
      }));
    },
  },
  async mounted() {
    this.$swal({
      title: "Loading...",
      text: "Please wait while the details are loading...",
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        this.$swal.showLoading();
      },
    });

    await this.getDepartmentListAction()
      .then(() => {
        this.$swal.close();
      })
      .catch((error) => {
        console.error("Error fetching departments:", error);
      });
  },

  methods: {
    ...mapActions("designationModule", [
      "getDesignationListAction",
      "addDesignationAction",
    ]),
    ...mapActions("departmentModule", ["getDepartmentListAction"]),

    checkNegative() {
      if (this.minimumSalary < 0) {
        this.minimumSalary = 0; // Set to 0 or show a warning if needed
      }

      if (this.maximumSalary < 0) {
        this.maximumSalary = 0; // Set to 0 or show a warning if needed
      }
    },

    errorRequired() {
      this.$swal({
        title: "Error!",
        text: "Please fill in minimum and maximum salary!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    errorSalary() {
      this.$swal({
        title: "Error!",
        text: " Maximum salary must be greater than minimum salary!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    formSubmitted() {
      const isValid = this.$refs.AddDesignationForm.validate();
      //console.log("SUCCESS", success);
      if (isValid) {
        this.loading = true;

        if (this.maximumSalary == "" || this.minimumSalary == "") {
          this.errorRequired();
          return;
        }

        if (this.maximumSalary < this.minimumSalary) {
          this.errorSalary();
          return;
        }

        let designationData = {
          departmentId: this.selectedDepartment,
          workingHours: this.workingHours,
          designationName: this.designationName,
          minimumSalary: this.minimumSalary,
          maximumSalary: this.maximumSalary,
        };

        console.log("dsignationdata", designationData);

        let loader = this.$swal({
          title: "Processing...",
          text: "Please wait while the Designation is being added",
          onOpen: () => {
            this.$swal.showLoading();
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
          buttonsStyling: false,
          showConfirmButton: false,
        });

        this.addDesignationAction(designationData)
          .then(() => {
            loader.close();
            this.success();
            this.$bvModal.hide("modal-id");
            this.loading = false;
            this.getDesignationListAction();
          })
          .catch((error) => {
            loader.close();
            this.error(error.response.data);
            this.loading = false;
            this.getDesignationListAction();
          });
      }
    },

    success() {
      this.$swal({
        title: "Designation added!",
        text: "You have successfully added the Designation!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$emit("DesignationAdded");
        }
      });
    },
    error(data) {
      this.$swal("Error!", this.getErrorString(data) || "Failed!", "error");
    },

    getErrorString(data) {
      let msg = "";
      if (data.errors) {
        for (let prop in data.errors) {
          msg += `<p>${prop.replace("$.", "")}: ${data.errors[prop]
            .toString()
            .replace("$.", "")}</p>`;
        }
      } else if (data.message) {
        msg += `<p>${data.message}</p>`;
      }
      return msg + "</div>";
    },
  },
};
</script>
